export const ErrorConstant = {
    error: 'Error',

    something_went_wrong: 'Something went wrong, please try again later.',

    forbidden: 'Forbidden',
    forbidden_message: 'You don\'t have permission to perform this action.',

    unauthorized: 'Unauthorized',
    unauthorized_message: 'Unauthorized Access! Please login again.',

    internal_server_error: `Internal Server Error!`,
}